import { AiOutlineDownload } from 'react-icons/ai';
import styled, { css } from 'styled-components';

interface CellItemProps {
  backgroundColor: string;
  color: string;
  fontWeight?: string | number;
}

interface ValueAreaProps {
  textAlign: string;
}

export const CellItem = styled.div<CellItemProps>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  align-self: center;
  ${({ color, backgroundColor, fontWeight }) => css`
    color: ${color};
    background-color: ${backgroundColor};
    font-weight: ${fontWeight};
  `};
`;
export const ValueArea = styled.div<ValueAreaProps>`
  flex: 1;
  width: 0;
  margin: 0 5px;
  text-align: ${({ textAlign }) => textAlign};
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Tooltip = styled.div`
  background-color: #333333;
  color: #fff;
  border-radius: 5px;
  padding: 5px;
  font-size: 13px;
  max-width: 500px;
  white-space: wrap;
`;

export const ExportIcon = styled(AiOutlineDownload)``;
